import type { FactTile } from './knownFacts';

interface FactTilesProps {
    tiles: readonly FactTile[];
    label: string;
}

export function FactTiles({ tiles, label }: FactTilesProps) {
    if (tiles.length === 0) return null;
    return (
        <dl className="grid grid-cols-3 gap-2" aria-label={label}>
            {tiles.map((tile) => (
                <div
                    key={tile.label}
                    className="flex min-w-0 flex-col gap-0.5 rounded-[10px] border border-gray-200 bg-white px-3 py-2.5"
                >
                    <dt className="truncate text-[11px] text-gray-500">{tile.label}</dt>
                    <dd className="break-words text-[13px] font-semibold leading-snug text-gray-900">
                        {tile.value}
                    </dd>
                </div>
            ))}
        </dl>
    );
}
